import React from "react";
import {Box, Typography} from "@mui/material";

interface Props {}

const Footer = ({}: Props) => {
    return <Box
        my={5}
        className="by-crqlar"
        alignSelf="center"
    >
        <a
            href="https://crqlar.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none'
            }}
        >
            <Typography
                variant="caption"
                sx={{ mr: 0.5 }}
            >
                Powered by Crqlar.com
            </Typography>

            <img
                src="https://res.cloudinary.com/crqlar/image/upload/c_thumb,w_200,g_face/v1665668665/prod/widget/crqlar-logo_agam3k.png"
                alt="Crqlar"
                style={{ width: 12, height: 12 }}
            />
        </a>
    </Box>
}

export default Footer;